/**
 * 배포 버전 감지 — 레거시 `pages/_app.js` version.json 폴링과 동일.
 */

/** 레거시 CHECK_INTERVAL — 1분 */
export const APP_VERSION_CHECK_INTERVAL_MS = 60_000;

export type AppVersionPayload = {
  version: string;
};

export const parseAppVersionPayload = (
  data: unknown,
): string | null => {
  if (
    data &&
    typeof data === 'object' &&
    'version' in data &&
    typeof (data as { version: unknown }).version === 'string' &&
    (data as { version: string }).version.trim() !== ''
  ) {
    return (data as { version: string }).version.trim();
  }
  return null;
};

/**
 * 이전에 본 버전과 서버 버전이 다르면 새로고침 유도.
 * 첫 응답(prev === null)에서는 배너를 띄우지 않는다.
 */
export const shouldPromptAppUpdate = (
  previousVersion: string | null,
  nextVersion: string | null,
): boolean =>
  previousVersion != null &&
  nextVersion != null &&
  previousVersion !== nextVersion;
